import {
    array,
    assign,
    boolean,
    literal,
    nullable,
    number,
    object,
    optional,
    string,
    union,
} from "superstruct";

import { REWARDS_REFERRAL_SHARE_CHANNELS } from "../../ReferralProgram/constants";

const RewardsReferralShareChannelEnabledSchema = object({
    isEnabled: boolean(),
});

const RewardsReferralFacebookShareSchema = assign(
    object({
        channelType: literal(REWARDS_REFERRAL_SHARE_CHANNELS.facebookShare),
    }),
    RewardsReferralShareChannelEnabledSchema
);

const RewardsReferralTwitterShareSchema = assign(
    object({
        channelType: literal(REWARDS_REFERRAL_SHARE_CHANNELS.twitterShare),
    }),
    RewardsReferralShareChannelEnabledSchema
);

const RewardsReferralWhatsAppShareSchema = assign(
    object({
        channelType: literal(REWARDS_REFERRAL_SHARE_CHANNELS.whatsAppShare),
    }),
    RewardsReferralShareChannelEnabledSchema
);

const RewardsReferralFacebookMessengerShareSchema = assign(
    object({
        channelType: literal(
            REWARDS_REFERRAL_SHARE_CHANNELS.facebookMessengerShare
        ),
    }),
    RewardsReferralShareChannelEnabledSchema
);

export const RewardsReferralEmailShareSchema = assign(
    object({
        channelType: literal(REWARDS_REFERRAL_SHARE_CHANNELS.emailShare),
        title: string(),
        message: string(),
    }),
    RewardsReferralShareChannelEnabledSchema
);

const RewardsReferralPinterestShareSchema = assign(
    object({
        channelType: literal(REWARDS_REFERRAL_SHARE_CHANNELS.pinterestShare),
    }),
    RewardsReferralShareChannelEnabledSchema
);

export const RewardsStorefrontValuesSettingsSchema = object({
    generalSettings: object({
        isPointsExpirationEnabled: boolean(),
        isApplyDiscountViaButton: boolean(),
        isCustomersCanSelfRefund: boolean(),
        pointsDecimalPlaces: number(),
        rewardPageHandle: nullable(string()),
    }),
    referralShareChannels: array(
        union([
            RewardsReferralFacebookShareSchema,
            RewardsReferralTwitterShareSchema,
            RewardsReferralWhatsAppShareSchema,
            RewardsReferralFacebookMessengerShareSchema,
            RewardsReferralEmailShareSchema,
            RewardsReferralPinterestShareSchema,
        ])
    ),
});
